import styled from 'styled-components'
import { CLICKABLE_COLOR } from '@CSSVars/colors'
import Flex from 'Components/Flex'
import AppButton from 'Components/AppButton'
import { NoPaddingCol } from 'Components/EnhacedFlexboxGrid'
import { BREAK_POINT_MD } from '@CSSVars/variables'

export const _TitleContainer = styled.div`
  margin-bottom: 12px;
  font-size: 16px;
  font-weight: 600;
  text-align: center;
`

export const _FilterLabel = styled.div`
  padding-top:20px;
  line-height: 22px;
  margin: 4px 0;
  font-weight: 600;
`

export const _Content = styled.div`
  width: 100%;
  z-index: 1;
//  position: absolute;
  box-shadow: var(--school-box-shadow);
  background: white;
`


export const _Container = styled(Flex)`

  gap: 12px;
  padding: 6px 12px 6px 14px;
  box-shadow: var(--school-box-shadow);
  background: white;
`
export const _ArrowContainer = styled(Flex)`
  margin-bottom: 2px;
  cursor: pointer;
  width: 100%;
  height: 100%;
  svg {
    fill: ${CLICKABLE_COLOR};
  }
`

export const _Label = styled.label`
  width: 18px;
  height: 18px;
  transition: transform 250ms;
  transform: rotate(-90deg);
`

export const _MultiSelectedBoxes = styled(Flex)`
  width: calc(100% + 12px);
  margin-top: -12px;
  @media screen and (max-width: ${BREAK_POINT_MD}) {
    max-width: 475px;
  }
  @media screen and (max-width: ${BREAK_POINT_MD}) {
    max-width: initial;
  }
`

export const _BoxItemContainer = styled(NoPaddingCol)`
  padding: 12px 12px 0 0;

  button {
    border-radius: 10px;
    width: 100%;
    margin: 0;
    padding: 0;
    height: 36px;
    div {
      padding: 0 6px;
      line-height: 22px;
    }
  }

`

export const _SchoolFilterSwitch = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin: 48px 0;

`
export const _ToggleLabel = styled.div`
  font-size: 14px;
  font-weight: 600;
  line-height: 22px;

`

export const _ApplyBtn = styled(AppButton)`
  &:hover {
    cursor: pointer;
  }
  height: 44px;
  font-size: 14px;
  line-height: 22px;
  font-weight: 600;
  width: 100%;
`
export const _BtnContainer = styled.div`
  justify-content: center;
  display: flex;
  flex-direction: row;
  margin-top: 48px !important;

`
export const _SwitchContainer = styled.div`
  width: 48px;
  height: 24px;
`

